class SearchDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-search-drawer]');
    this.overlay = document.querySelector('[data-search-drawer-overlay]');
    this.closeButton = document.querySelector('[data-search-drawer-close]');
    this.openButton = document.querySelector('[data-search-drawer-toggle]');
    this.openButtonMobile = document.querySelector('[data-search-drawer-toggle-mobile]');
    this.input = this.drawer?.querySelector('[data-search-drawer-input]');
    
    this.init();
  }

  init() {
    this.openButton?.addEventListener('click', this.open.bind(this));
    this.openButtonMobile?.addEventListener('click', this.open.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
    this.overlay?.addEventListener('click', this.close.bind(this));
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isOpen() && !this.drawer?.contains(e.target) && !this.openButton?.contains(e.target) && !this.openButtonMobile?.contains(e.target)) {
        this.close();
      }
    });
  }

  open() {
    if (!this.drawer) return;
    
    this.drawer.classList.add('search-drawer--open');
    document.body.classList.add('search-drawer-open');
    
    // Focus the search input
    setTimeout(() => {
      this.input?.focus();
    }, 100);
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  close() {
    if (!this.drawer) return;
    
    this.drawer.classList.remove('search-drawer--open');
    document.body.classList.remove('search-drawer-open');
    
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Return focus to the open button
    this.openButton?.focus();
  }

  isOpen() {
    return this.drawer?.classList.contains('search-drawer--open');
  }
}

// Initialize SearchDrawer globally
document.addEventListener('DOMContentLoaded', () => {
  window.searchDrawerInstance = new SearchDrawer();
  
  // Handle focus trap
  document.addEventListener('keydown', (e) => {
    const drawer = document.querySelector('.search-drawer--open');
    if (!drawer || e.key !== 'Tab') return;

    const focusableElements = drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });
});